import { useEffect, useState } from 'react';
import { api, ErroApi, type Recompensa, type ResgateFeito } from '../api';
import { navegar, voltar } from '../rota';
import { Moeda } from '../orbita';
import { Foto } from '../../../compartilhado/Foto';
import { Carregando } from '../../../compartilhado/Espera';
import { useAgir } from '../../../compartilhado/useAgir';

const ateQuando = (dia: string) => {
  const [, mes, d] = dia.split('-');
  return `válido até ${d}/${mes}`;
};

/**
 * A tela 4 do mockup: o prêmio de perto, o "seu saldo depois do resgate", e o
 * botão que fala o preço. As condições ficam em texto corrido, como lá — e o
 * "vale N dias" do cupom é dito AQUI, antes do resgate (decisão de 21/08).
 */
export function Detalhe({ id, aoFalhar }: { id: string; aoFalhar: (e: unknown) => void }) {
  const [premio, setPremio] = useState<Recompensa | null>(null);
  const [erro, setErro] = useState('');
  /*
   * ⚠️ Resgatar CRIA CUPOM e DEBITA as moedas na hora (invariante 7). Dois
   * cliques no mesmo quadro eram dois cupons e o saldo pago duas vezes — e o
   * `useState` que segurava isto só chega ao DOM no quadro seguinte, tarde
   * demais. A trava do `useAgir` é síncrona.
   */
  const { ocupado, agir } = useAgir();

  useEffect(() => {
    api
      .recompensa(id)
      .then(setPremio)
      .catch((e) => {
        setErro(e instanceof ErroApi ? e.message : 'não consegui carregar');
        aoFalhar(e);
      });
  }, [id, aoFalhar]);

  if (erro) return <div className="erro-tela">{erro}</div>;
  /* Primeira abertura: o prêmio ainda não chegou, não há nada para cobrir. */
  if (!premio)
    return (
      <div className="espera-tela">
        <Carregando />
      </div>
    );

  const depois = premio.saldoMoedas - premio.custoMoedas;
  const alcancavel = depois >= 0;

  async function resgatar() {
    await agir(async () => {
      setErro('');
      try {
        const feito: ResgateFeito = await api.resgatar(premio!.id);
        navegar(`/cupom/${feito.codigo}`, true);
      } catch (e) {
        setErro(e instanceof ErroApi ? e.message : 'não consegui resgatar');
      }
    });
  }

  const condicoes = [
    premio.vigenciaFim ? ateQuando(premio.vigenciaFim) : null,
    premio.lojas?.length ? 'lojas selecionadas' : 'todas as lojas participantes',
    premio.limitePorMes ? `limite de ${premio.limitePorMes} por mês` : null,
    `o cupom vale ${premio.cupomValeDias} dias`,
  ].filter(Boolean);

  return (
    <div className="tela dt">
      <div className="dt-foto">
        {/* ⚠️ Aqui a foto não substitui o bloco, ela entra DENTRO dele: o botão
            de voltar é filho posicionado deste mesmo `.dt-foto`, e trocar o
            contêiner levaria a seta junto. */}
        <Foto
          capa={premio.capa}
          alt={premio.nome}
          vazio={<span>foto grande · {premio.nome}</span>}
        />
        <button className="volta" onClick={voltar} aria-label="voltar">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path d="M10 3 5 8l5 5" fill="none" stroke="var(--ink)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <div className="dt-corpo">
        <div className="dt-cabeca">
          <div>
            <h1 className="dt-nome">{premio.nome}</h1>
            {premio.descricao && <p className="dt-descricao">{premio.descricao}</p>}
          </div>
          <span className="selo-custo cheio grande">
            <Moeda tamanho={10} />
            <span>{premio.custoMoedas}</span>
          </span>
        </div>

        <div className="dt-depois">
          <span>seu saldo depois do resgate</span>
          <span className="dt-depois-valor">
            <Moeda />
            <span>
              {Math.max(0, depois)} {Math.abs(depois) === 1 ? 'moeda' : 'moedas'}
            </span>
          </span>
        </div>

        <p className="dt-condicoes">{condicoes.join(' · ')}</p>
        {erro && <div className="en-erro">{erro}</div>}

        <div className="dt-pe">
          <button
            className="botao-cheio"
            disabled={!alcancavel || ocupado}
            onClick={() => void resgatar()}
          >
            {ocupado
              ? 'Gerando cupom…'
              : alcancavel
                ? `Resgatar por ${premio.custoMoedas} moedas`
                : `Faltam ${-depois} ${-depois === 1 ? 'moeda' : 'moedas'}`}
          </button>
        </div>
      </div>
    </div>
  );
}
